export const PROGRESS_MIN_VALUE = "{{PROGRESS_MIN_VALUE}}";
export const PROGRESS_MAX_VALUE = "{{PROGRESS_MAX_VALUE}}";
export const PROGRESS_VALUE = "{{PROGRESS_VALUE}}";
